import { z } from 'zod'

import { AccommodationValidation } from '../../../../../../_kernel/Accommodation'
import { AddressValidation } from '../../../../../../_kernel/Address'
import { CityValidation } from '../../../../../../_kernel/City'
import { CountryValidation } from '../../../../../../_kernel/Country'
import { DistanceToCityCenterValidation } from '../../../../../../_kernel/DistanceToCityCenter'
import { GeoCoordinateValidation } from '../../../../../../_kernel/GeoCoordenate'
import { IDValidation } from '../../../../../../_kernel/ID'
import { NameValidation } from '../../../../../../_kernel/Name'
import { SlugValidation } from '../../../../../../_kernel/Slug'
import { StarsValidation } from '../../../../../../_kernel/Stars'
import { LanguageValidation } from '../../../../../../shared/domain/Language'
import { RatingValidation } from '../../../../../../_kernel/Rating'
import { NumberOfCommentsValidation } from '../../../../../../_kernel/NumberOfComments'
import { PathValidation } from '../../../../../../_kernel/Path'
import { ImageBucketValidation } from '../../../../../../_kernel/ImageBucket'
import { ImageSizeValidation } from '../../../../../../_kernel/ImageSize'
import { ImageCodeValidation } from '../../../../../../_kernel/ImageCode'
import { ImageCategoryOrderValidation } from '../../../../../../_kernel/ImageCategoryOrder'

export const GETpropertiesByIDsQuery = z.object({
  lang: LanguageValidation.shape.value,
  id_properties: z.string().regex(/^[^,]+(?:,[^,]+)*$/), // List of id comma separated
})

export type GETpropertiesByIDsResponse = z.infer<typeof GETpropertiesByIDsResponse>
export const GETpropertiesByIDsResponse = z.object({
  properties: z
    .object({
      id_property: z.number().min(0),
      name: NameValidation.shape.value,
      country: CountryValidation.shape.value,
      slug: SlugValidation.shape.value,
      accommodation_type: AccommodationValidation.shape.value,
      latitude: GeoCoordinateValidation.shape.latitude,
      longitude: GeoCoordinateValidation.shape.longitude,
      address: AddressValidation.shape.value,
      city: CityValidation.shape.value,
      stars: StarsValidation.shape.value,
      distance: DistanceToCityCenterValidation.shape.value.nullable().optional(),
      in_center: z.boolean().nullable().optional().default(false),
      city_slug: SlugValidation.shape.value,
      rating: z.union([RatingValidation.shape.value, z.string()]).optional(),
      facilities: z.object({}).array().optional(),
      rating_count: NumberOfCommentsValidation.shape.value.optional(),
      ratings: z
        .object({
          id_tripadvisor: IDValidation.shape.value.optional(),
          rating: z.union([z.number().min(0), z.string()]).optional(),
          ranking_out_of: z.number().positive().optional(),
          ranking: z.number().positive().optional(),
          review_rating_count: z
            .object({
              rating: RatingValidation.shape.value,
              recount: z.number().positive().optional(),
            })
            .array()
            .optional(),
          subratings: z
            .object({
              name: NameValidation.shape.value,
              value: RatingValidation.shape.value,
              localized_name: z.string(),
            })
            .array()
            .optional(),
          trip_types: z
            .object({
              name: z.string(),
              value: z.number(),
            })
            .array()
            .optional(),
          rating_count: NumberOfCommentsValidation.shape.value.optional(),
        })
        .optional(),
      images: z
        .object({
          path: PathValidation.shape.value,
          bucket: ImageBucketValidation.shape.value,
          width: ImageSizeValidation.shape.width,
          height: ImageSizeValidation.shape.height,
          code: ImageCodeValidation.shape.value,
          categoryOrder: ImageCategoryOrderValidation.shape.value,
        })
        .array(),
    })
    .array(),
})
